// extracted by mini-css-extract-plugin
export default {"explanation":"LockedTimelineModal_explanation__yJDjy","contactTitle":"LockedTimelineModal_contactTitle__bQcmj","contactDetails":"LockedTimelineModal_contactDetails__AxJiN"};